import { DestinationTypeBm, type LensDestination, MyLensesLensStatus } from "../../gql-generated/types";

import { type LensStatusDisplayMeta, lensStatusMap, publishedStatusEntry } from "./lensStatusMap";
import { DESTINATION_BASED_LIVE_STATUSES, LOCKED_BASE_STATUSES } from "./makeLensActionsConfigBasedOnStatus";

export const makeDisplayStatus = (
    status: MyLensesLensStatus,
    destinations: readonly LensDestination[],
): LensStatusDisplayMeta => {
    const baseStatusMeta = lensStatusMap[status];
    if (destinations.length === 0 || LOCKED_BASE_STATUSES.has(status)) {
        return baseStatusMeta;
    }

    const hasLiveDestinations = destinations.some((destination) =>
        DESTINATION_BASED_LIVE_STATUSES.has(destination.status),
    );

    const rejectedDestinations = destinations.filter(
        (destination) => destination.status === MyLensesLensStatus.LensStatusRejected,
    );

    if (rejectedDestinations.length === 0) {
        return hasLiveDestinations ? publishedStatusEntry : baseStatusMeta;
    }

    const communityDestination = destinations.find(
        (destination) =>
            destination.destinationType === DestinationTypeBm.DestinationTypeUser ||
            destination.destinationType === DestinationTypeBm.DestinationTypePublicProfile,
    );

    if (communityDestination) {
        const communityStatus = communityDestination.status;
        return DESTINATION_BASED_LIVE_STATUSES.has(communityStatus)
            ? publishedStatusEntry
            : lensStatusMap[communityStatus];
    }

    return baseStatusMeta;
};
